import Survey from "./pagees/survey/Survey.jsx";
import "./App.css";

function App() {
  return (
    <div className="App">
      <div className="ContentContainer">
        <Survey />
      </div>
      {/*{window.innerWidth < 500 ? null : <Footer />} */}
    </div>
  );
}

export default App;
